import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Sizes from 'UI/sizes';
import Placeholder from './Placeholder';
import Initials from './Initials';

export default class Avatar extends React.Component
{
    static propTypes = {
        src: PropTypes.string,
        rounded: PropTypes.bool,
        circular: PropTypes.bool,
        size: PropTypes.string,
        initials: PropTypes.string,
    };

    static defaultProps = {
        src: null,
        rounded: false,
        circular: false,
        size: Sizes.MEDIUM,
        initials: null,
    };

    render()
    {
        return <div className="flex-shrink-0 group block focus:outline-none">
            <div className="flex items-center">
                { this.renderPicture() }
            </div>
        </div>;
    }

    renderPicture()
    {
        const classes = classNames(
            this.props.className,
            {
                "inline-block select-none": true,
                "overflow-hidden": ! this.props.src || ! this.props.initials,
                "rounded-md": this.props.rounded || ! this.props.circular,
                "rounded-full": this.props.circular,
                "h-6 w-6": this.props.size === Sizes.EXTRA_SMALL,
                "h-8 w-8": this.props.size === Sizes.SMALL,
                "h-10 w-10": this.props.size === Sizes.MEDIUM,
                "h-12 w-12": this.props.size === Sizes.LARGE,
                "h-14 w-14": this.props.size === Sizes.EXTRA_LARGE,
            }
        );

        if ( this.props.src ) {
            return <img className={classes} src={this.props.src} alt="" />;
        }

        if ( this.props.initials ) {
            return <Initials className={classes} initials={this.props.initials} size={this.props.size} />;
        }

        return <Placeholder className={classes} />;
    }
}
